import React from "react";

import Cx from "classnames";
import styles from "./styles.scss";
import { Helmet } from "react-helmet";
import Navigation from "~/app/components/Navigation";
import LogoTribe from "~/app/components/LogoTribe";
const imageUrl = new URL("../../assets/images/bg-obscura37-big.jpg", import.meta.url)
import Img from "~/app/components/Img";
import Form from "~/app/components/Form";
import { emailSignUpForm } from "./emailSignUpForm";
import Heading from "~/app/components/Heading";
import specStyles from "../Specs/styles.scss";
import Video from "~/app/components/Video";

const obscuraSpecifications = [
  { label: "Focal Length", value: <>37<span>mm</span></> },
  { label: "Mount", value: "ARRI PL-Mount" },
  { label: "Pupil diameter", value: <>277 <span>um</span></> },
  { label: "F-stop equivalent", value: "f/133" },
  { label: "Substrate thickness", value: <>9 <span>um</span></> },
  { label: "Weight", value: "47g (without packaging)" },
  { label: "Front cover diameter", value: <>55<span>mm</span></> },
  { label: "Depth front to back", value: <>23<span>mm</span></> },
]
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFormSubmitted: false,
    };
  }

  handleFormSuccess = () => {
    this.setState({
      isFormSubmitted: true,
    });
  }

  displaySubmitButton = (event) => {
    const submitButton = document.querySelector('button[type="submit"]');

    if (event.target.value) {
      submitButton.classList.add(styles.formButtonVisible);
    } else {
      submitButton.classList.remove(styles.formButtonVisible);
    }
  }

  renderForm = () => {
    let formTemplate = null;
    if (!this.state.isFormSubmitted) {
      formTemplate = <Form
        fields={emailSignUpForm.fields}
        buttonLabel="submit"
        onSubmit={emailSignUpForm.callback}
        onSuccess={this.handleFormSuccess}
        onChange={this.displaySubmitButton}
        classNameButton={Cx(styles.formButton)}
        classNameField={Cx(styles.formField)}
        classNameContainer={Cx(styles.form)}
        withHiddenSubmitButton={true}
        withExpandingLine={true}
      />
    } else {
      formTemplate = <div className={Cx(styles.submitMessage)}>Thanks for registering your interest in OBSCURA<span>37</span>, we'll be in touch soon</div>
    }
    return (
      <>
        <Heading level={2} className={Cx(styles.formHeading)}>
          <span className={Cx(styles.formHeadingAccent)}>Register</span> your interest
        </Heading>
        {formTemplate}
      </>
    )
  }

  renderSpecifications = () => (
    <div className={Cx(styles.specsContainer)}>
      <Heading level={2} className={Cx(styles.specsHeading)}>
        Specifications
      </Heading>
      <div className={Cx(specStyles.rows, styles.specRows)}>
        {obscuraSpecifications.map(spec => (
          <div key={spec.label} className={Cx(specStyles.row, styles.specRow)}>
            <div className={Cx(specStyles.colLeft)}>
              <div className={Cx(specStyles.label)}>{spec.label}</div>
              <div className={Cx(specStyles.line)} />
            </div>
            <div className={Cx(specStyles.colRight)}>{spec.value}</div>
          </div>
        ))}
      </div>
    </div>
  )

  render() {
    const meta = {
      title: "Obscura37 by Blackwing7",
      description: ""
    }

    return (
      <div>
        <Helmet>
          <title>{meta.title}</title>
          <meta name='description' content={meta.page} />
          <link rel="canonical" href={`${window.location.origin}/obscura`} />
        </Helmet>
        <Navigation />
        <LogoTribe />
        <div className={Cx(styles.page)}>
          <div className={Cx(styles.container)}>
            <div className={Cx(styles.header)}>
              <div className={Cx(styles.headerObscura)}>OBSCURA</div>
              <div className={Cx(styles.headerThirtySeven)}>37</div>
            </div>
            <div className={Cx(styles.imageContainer)}>
              <Img src={imageUrl} className={Cx(styles.image)} readyClassName={Cx(styles.imageReady)} />
            </div>
            <div className={Cx(styles.description)}>
              OBSCURe/a is our attempt to hand those who we love the most,
              our supporters, a tool that will allow them to reconnect to their
              childhood senses. The origin story of their first tastes, their first
              smells. As cinematographers, a reconnection to the origin of our
              art form, the first lens.
            </div>
            <div className={Cx(styles.videoSection)}>
              <Video
                src="https://player.vimeo.com/progressive_redirect/playback/1142420900/rendition/1080p/file.mp4?loc=external&log_user=0&signature=455e8c6d1d6b5c767e6ec25d5c273e7440a812ce32db05552dd866a004133c8d"
                width="1920"
                height="1080"
                isCurrent
                isCurrentOrNext
                loop
              />
            </div>
            {this.renderSpecifications()}
            <div className={Cx(styles.buyNowContainer)}>
              <a
                href="https://blackslate7.com/cart/47393294188682:1?return_to=/checkout"
                className={Cx(styles.buyNowButton)}
              >
                Order Now
              </a>
            </div>
            <div className={Cx(styles.signUp)}>
              {this.renderForm()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
